__turbopack_context__.v({
  "baseModal": "styles-module__NGcEdG__baseModal",
  "baseModalFullScreen": "styles-module__NGcEdG__baseModalFullScreen",
  "basePanelContainer": "styles-module__NGcEdG__basePanelContainer",
  "collapsePanelButton": "styles-module__NGcEdG__collapsePanelButton",
  "filterContainer": "styles-module__NGcEdG__filterContainer",
  "markerActive": "styles-module__NGcEdG__markerActive",
  "markerClusterCount": "styles-module__NGcEdG__markerClusterCount",
  "markerLogoDefault": "styles-module__NGcEdG__markerLogoDefault",
  "mobileDrawerContentHeight": "styles-module__NGcEdG__mobileDrawerContentHeight",
  "modalForm": "styles-module__NGcEdG__modalForm",
  "modalRegisterContent": "styles-module__NGcEdG__modalRegisterContent",
  "popoverContainer": "styles-module__NGcEdG__popoverContainer",
  "searchResultsContainer": "styles-module__NGcEdG__searchResultsContainer",
  "xlCollapseDrawer": "styles-module__NGcEdG__xlCollapseDrawer",
  "xlSearchResultPanel": "styles-module__NGcEdG__xlSearchResultPanel",
});
